export default { sha: 'fe05ebc700eb38ea9d79d083afd1f78f63cded19', buildNumber: 'undefined' }
